module.exports = __webpack_public_path__ + "static/media/photo-1547918641-759efa55629a.3708cc9e.jfif";